import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import type { ConfigState } from './config';
import langReducer, { type LangState } from './configuration/lang/langSlice';
import loginReducer, { type LoginState } from './configuration/login/loginSlice';
import configReducer from './configuration/setup/configReducer';
import tokenReducer, { type AccessTokenState } from './configuration/tokenHandling/tokenSlice';
import { hereAutoSuggestApi } from './features/components/common/addressSearch/hereAutoSuggestApi';
import { geofenceBottomSheetReducer } from './features/map/redux/geofenceBottomSheet.reducer';
import { onboardingReducer } from './features/onboarding/redux/oboarding.redux';
import { positionSharingReducer } from './features/positionSharingDialog/redux/positionSharing.redux';
import appReducer, { type AppState } from './features/reducers/appReducer';
import bookingsReducer from './features/reducers/bookingsReducer';
import { geofenceReducer } from './features/reducers/geofenceReducer';
import mapReducer from './features/reducers/mapReducer';
import poiReducer from './features/reducers/poiReducer';
import { uploadReducer } from './features/reducers/uploadReducer';

export interface State {
    tokenHandling: AccessTokenState;
    login: LoginState;
    lang: LangState;
    config?: ConfigState;
    app: AppState;
    form: ReturnType<typeof formReducer>;
    poi: ReturnType<typeof poiReducer>;
    newMap: ReturnType<typeof mapReducer>;
    geofence: ReturnType<typeof geofenceReducer>;
    upload: ReturnType<typeof uploadReducer>;
    bookings: ReturnType<typeof bookingsReducer>;
    positionSharing: ReturnType<typeof positionSharingReducer>;
    onboarding: ReturnType<typeof onboardingReducer>;
    geofenceBottomSheet: ReturnType<typeof geofenceBottomSheetReducer>;
    [hereAutoSuggestApi.reducerPath]: ReturnType<typeof hereAutoSuggestApi.reducer>;
}

export const rootReducer = () =>
    combineReducers<State>({
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        poi: poiReducer,
        form: formReducer,
        newMap: mapReducer,
        geofence: geofenceReducer,
        upload: uploadReducer,
        bookings: bookingsReducer,
        positionSharing: positionSharingReducer,
        onboarding: onboardingReducer,
        geofenceBottomSheet: geofenceBottomSheetReducer,
        [hereAutoSuggestApi.reducerPath]: hereAutoSuggestApi.reducer,
    });
